

import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';

import DirectoriesModule from '@/store/directories';
import AdministratorsModule from '@/store/administrators';

@Component({
    components: {
        Layout,
        ListBlock,
    }
})
export default class AdministratorsPage extends Vue {
    repository = AdministratorsModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }

    get currentTab() {
        return DirectoriesModule.allTabs.administrators.id;
    }

    get filterSettings() {
        return this.repository.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'administrators_create' });
    }

    async updateList() {
        await this.repository.filter.updateFilter();
        await this.repository.updatePage('1');
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.filter.resetFilter();
        await this.repository.updatePage('1');
    }
}
